import { Chip, TablePagination } from "@mui/material";
import useLocales from "../../../hooks/useLocales";
import {
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

const CustomPagination = () => {
  const { translate } = useLocales();
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const { pageSize, rowCount } = apiRef.current.state.pagination;

  return (
    <>
      <Chip label={`${translate("actions.page")} ${page + 1}`} />
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        color="primary"
        count={rowCount}
        rowsPerPage={pageSize}
        page={page}
        onPageChange={(event: any, value: number) =>
          apiRef.current.setPage(value)
        }
        onRowsPerPageChange={(event: any) => {
          apiRef.current.setPageSize(parseInt(event.target.value));
        }}
      />
    </>
  );
};

export default CustomPagination;
